export * from "./Header";
export * from "./Login";
export * from "./Footer";
export * from "./Contact";
export * from "./Error";
export * from "./RestaurantMenuList";
export * from "./NewBodyPage";
// export * from "./Cart";
export * from "./RestaurantDetails";
export * from "./Welcome";
export * from "./NewCart";
export * from "./Modals";
